import objectReduce from 'fast-loops/lib/objectReduce';

export default function createNode(nodes, score, _ref) {
  var type = _ref.type,
      media = _ref.media,
      support = _ref.support;

  var head = document.head || {};

  var node = document.createElement('style');
  node.setAttribute('data-fela-type', type);
  node.type = 'text/css';

  if (support) {
    node.setAttribute('data-fela-support', 'true');
  }

  if (media) {
    node.media = media;
  }

  // we calculate the most next bigger style node
  // to correctly inject the node just before it
  var moreSpecificReference = objectReduce(nodes, function (closest, node, reference) {
    return node.score > score && (!closest || nodes[closest].score > node.score) ? reference : closest;
  }, undefined);

  if (moreSpecificReference) {
    head.insertBefore(node, nodes[moreSpecificReference].node);
  } else {
    head.appendChild(node);
  }

  return node;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/es/dom/connection/createNode.js
// module id = 1176
// module chunks = 0